import React from "react"
import classes from "./contact.module.css"

const Contact = () => {
  return (
    <div className={classes.Contact} id="contact">
      <h2>Contact us:</h2>
      <p>
        <i className="fa fa-map-o" style={{ fontSize: "36px" }}></i> &nbsp;Smart
        Skin, 339 Charminster Road, Bournemouth, BH8 9QR
      </p>
      <p>
        <i className="fa fa-envelope" style={{ fontSize: "36px" }}></i>
        &nbsp;hightechbeauty@gmail.com
      </p>
      <p>
        <i className="fa fa-phone-square" style={{ fontSize: "36px" }}></i>
        &nbsp;07512009522
      </p>
      <p>
        <a href="https://www.facebook.com/SmartSkinSalon/" target="_blank">
          <i
            className="fa fa-facebook-official"
            style={{ fontSize: "36px", color: "white" }}
          ></i>
        </a>
        &nbsp;&nbsp;
        {/*<a href="">
          <i
            class="fa fa-instagram"
            style={{ fontSize: "36px", color: "white" }}
          ></i>
  </a>*/}
      </p>
    </div>
  )
}

export default Contact
